import "core-js/modules/es.object.keys.js";
import RichText from '~/components/ui/RichText.vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
export default defineComponent({
  name: 'ItemImageTextStandardWithoutTwicPics',
  components: {
    RichText: RichText
  },
  props: {
    image: Object,
    text: Object,
    title: [Object, String],
    classes: {
      type: Object,
      default: function _default() {}
    },
    link: [Object, String],
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var customRenderer = function customRenderer() {
      return {
        renderNode: {
          paragraph: function paragraph(node, next) {
            return "<h4>".concat(next(node.content), "</h4>");
          }
        },
        renderMark: {}
      };
    };
    var isTextEmpty = computed(function () {
      return !props.text || Object.keys(props.text).length === 0 && props.text.constructor === Object;
    });
    var getImgUrl = computed(function () {
      var _props$image$fields, _props$image$fields$f;
      return props.image && ((_props$image$fields = props.image.fields) === null || _props$image$fields === void 0 ? void 0 : (_props$image$fields$f = _props$image$fields.file) === null || _props$image$fields$f === void 0 ? void 0 : _props$image$fields$f.url) || null;
    });
    var computedClasses = useGetDisplayOptionsClasses(props.displayOptions);
    return {
      customRenderer: customRenderer,
      computedClasses: computedClasses,
      getImgUrl: getImgUrl,
      isTextEmpty: isTextEmpty
    };
  }
});